// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const ArrowRightLargeIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13H5c-.6 0-1-.4-1-1s.4-1 1-1h14c.6 0 1 .4 1 1s-.4 1-1 1z"/><path d="M12 20c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l6.3-6.3-6.3-6.3c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l7 7c.4.4.4 1 0 1.4l-7 7c-.2.2-.4.3-.7.3z"/></svg>'} />;

ArrowRightLargeIcon.displayName = 'ArrowRightLargeIcon';

export default ArrowRightLargeIcon;
